module.exports = __webpack_public_path__ + "img/diagram.f28321c3.png";